<app-loader *ngIf="isDisabled"></app-loader>
<form name="SiteBranchForm" (ngSubmit)="Validate(SiteBranchForm)" #SiteBranchForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Site/Branch Mapping</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-1" ngbButtonLabel
                        *ngIf="this.FormData.ESS_SiteWiseDeviceDetailsID == 0 || (this.FormData.ESS_SiteWiseDeviceDetailsID > 0 && this.common.ToLowerCase(this.FormData.CodeType) == 'branch')">
                        <input class="form-check-input" type="radio" value="Branch" name="CodeType"
                            [(ngModel)]="FormData.CodeType" [ngModelOptions]="{standalone: true}"
                            (change)="ComboChange()">
                        Branch
                    </label>
                    <label class="form-check-label link-dark px-1" ngbButtonLabel
                        *ngIf="this.FormData.ESS_SiteWiseDeviceDetailsID == 0 || (this.FormData.ESS_SiteWiseDeviceDetailsID > 0 && this.common.ToLowerCase(this.FormData.CodeType) == 'site')">
                        <input class="form-check-input" type="radio" value="Site" name="CodeType"
                            [(ngModel)]="FormData.CodeType" [ngModelOptions]="{standalone: true}"
                            (change)="ComboChange()">
                        Site
                    </label>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <label for="BranchID" class="text-label-dark">Branch<span class="mandatory-field">*</span></label>
                    <ng-select name="BranchID" placeholder="Select Branch" [(ngModel)]="FormData.BranchID"
                        [selectOnTab]="true" required (change)="ComboLoad('Client');ComboLoad('Site')">
                        <ng-option *ngFor="let Branch of Branchs"
                            [value]="Branch.BranchMasterID">{{Branch.BranchName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch
                    </div>
                </div>
                <div class="col-md-12" *ngIf="this.FormData.CodeType == 'Site'">
                    <label for="ClientID" class="text-label-dark">Client <span class="mandatory-field">*</span></label>
                    <ng-select name="ClientID" placeholder="Select Client" [(ngModel)]="FormData.ClientID"
                        [selectOnTab]="true" required (change)="ComboLoad('Site')">
                        <ng-option *ngFor="let Client of Clients"
                            [value]="Client.ClientGroupMasterID">{{Client.ClientGroupName}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-md-12" *ngIf="this.FormData.CodeType == 'Site'">
                    <label for="SiteId" class="text-label-dark">Site <span class="mandatory-field">*</span></label>
                    <ng-select name="SiteId" placeholder="Select Site" [(ngModel)]="FormData.SiteID"
                        [selectOnTab]="true" required>
                        <ng-option *ngFor="let Site of Sites" [value]="Site.SiteMasterID">{{Site.SiteName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select site
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-6">
                    <label for="DeviceSerialNumber" class="text-label-dark">Serial Number <span
                            class="mandatory-field">*</span></label>
                    <ng-select name="DeviceSerialNumber" placeholder="Select Device Serial No"
                        [(ngModel)]="FormData.DeviceSerialNumber" [selectOnTab]="true" required>
                        <ng-option *ngFor="let Device of Devices"
                            [value]="Device.DeviceSerialNo">{{Device.DeviceSerialNo}}</ng-option>
                    </ng-select>
                    <!-- <input type="text" class="form-control" placeholder="Ex. DMP001XX0" id="DeviceSerialNumber"
                        name="DeviceSerialNumber" [(ngModel)]="FormData.DeviceSerialNumber"
                        #DeviceSerialNumber="ngModel" maxlength="100" required> -->
                    <div class="invalid-feedback">
                        Please select device serial number!
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="Module" class="text-label-dark">Model <span class="mandatory-field">*</span></label>
                    <input type="text" class="form-control" placeholder="Ex. AI F11" id="Module" name="Module"
                        [(ngModel)]="FormData.Module" #Module="ngModel" maxlength="100" required>
                    <div class="invalid-feedback">
                        Please enter module!
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer m-2">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary mx-1" [disabled]="isDisabled"
                    [routerLink]="['/attendancedevice/sitebranchmapping']"><i class="bi bi-arrow-left"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="((this.FormData.ESS_SiteWiseDeviceDetailsID == 0 && this.common.PageRight.IsAdd) || (this.FormData.ESS_SiteWiseDeviceDetailsID > 0 && this.common.PageRight.IsEdit))"><i
                        class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>